import React, { useEffect,useState } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from "../../server/axios.js";

const Company_sub_material = () => {
  const location = useLocation(); // 추가된 부분
  const materialArr = location.state?.data; // 추가된 부분
  const materialName = materialArr[0]; // 추가된 부분
  const materialCode = materialArr[1]; // 추가된 부분
  //firstchart

  //table
  const [Weight, setWeight] = useState('weight');
  const [TableTitle_buy, setTableTitle_buy] = useState([]);
  const [TableData_buy, setTableData_buy] = useState([]);
  const [TableTitle_sell, setTableTitle_sell] = useState([]);
  const [TableData_sell, setTableData_sell] = useState([]);

  //tableSelection
  const [alignment, setAlignment] = useState('weight');
  useEffect(()=>{ 
    getbuycompanydata()
    async function getbuycompanydata(){
      const buycompanydata = await axiosInstance.get(`/material/buycompany?materialcode=${materialCode}&type=${Weight}`);
      const tabledata = [];
      for(let i = 0; i < buycompanydata.data.buycompany.length; i++){
        const dataArr = [];
        for(let j = 0; j < buycompanydata.data.buycompany[0].length; j++){
          if(j > 1){
            dataArr.push(Math.round(Number(buycompanydata.data.buycompany[i][j])*100)/100); 
            continue;
          }
          dataArr.push(buycompanydata.data.buycompany[i][j]);
        }
        tabledata.push(dataArr);
      }
      setTableTitle_buy([...buycompanydata.data.buymenulist]);
      setTableData_buy([...tabledata]);
    }
  },[Weight])

  useEffect(()=>{
    getsellcompanydata()
    async function getsellcompanydata(){
      const sellcompanydata = await axiosInstance.get(`/material/sellcompany?materialcode=${materialCode}&type=${Weight}`);
      const tabledata = [];
      for(let i = 0; i < sellcompanydata.data.sellcompany.length; i++){
       const dataArr = [];
       for(let j = 0; j < sellcompanydata.data.sellcompany[0].length; j++){
         if(j > 1){
           dataArr.push(Math.round(Number(sellcompanydata.data.sellcompany[i][j])*100)/100); 
           continue;
         }
         dataArr.push(sellcompanydata.data.sellcompany[i][j]);
       }
       tabledata.push(dataArr);
     }
      setTableTitle_sell([...sellcompanydata.data.sellmenulist]);
      setTableData_sell([...tabledata]);
    }
  },[Weight])

  const commaNumber = (number) => {
     return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const sortingTable = (sortingnumber) => {
    const checkingSort = TableTitle_sell[sortingnumber].indexOf('\n🔻');
    const dummyMenu = [];
    for(let i = 0; i < TableTitle_sell.length; i++){
      let menu = TableTitle_sell[i];
      menu = menu.replace(/\n🔺/gi, '');
      menu = menu.replace(/\n🔻/gi, '');
      if(i === sortingnumber){
        menu = checkingSort === -1 ? menu + '\n🔻' : menu = menu + '\n🔺';
      }
      dummyMenu.push(menu);
    }
    const sortDirection = (sortingnumber,sortmark) =>{
      let direction = -1;
      if(sortmark === -1){direction = 1}
      const dummyItemArr = TableData_sell.sort((a, b) => {
        if (a[sortingnumber] < b[sortingnumber])return 1*direction;
        if (a[sortingnumber] > b[sortingnumber])return -1*direction;
        return 0;
        });
      return dummyItemArr;
    }
    const dummyArr = sortDirection(sortingnumber,checkingSort);
    setTableTitle_sell([...dummyMenu])
    setTableData_sell([...dummyArr])
  }
  const sortingTable2 = (sortingnumber) => {
    const checkingSort = TableTitle_buy[sortingnumber].indexOf('\n🔻');
    const dummyMenu = [];
    for(let i = 0; i < TableTitle_buy.length; i++){
      let menu = TableTitle_buy[i];
      menu = menu.replace(/\n🔺/gi, '');
      menu = menu.replace(/\n🔻/gi, '');
      if(i === sortingnumber){
        menu = checkingSort === -1 ? menu + '\n🔻' : menu = menu + '\n🔺';
      }
      dummyMenu.push(menu);
    }
    const sortDirection = (sortingnumber,sortmark) =>{
      let direction = -1;
      if(sortmark === -1){direction = 1}
      const dummyItemArr = TableData_buy.sort((a, b) => {
        if (a[sortingnumber] < b[sortingnumber])return 1*direction;
        if (a[sortingnumber] > b[sortingnumber])return -1*direction;
        return 0;
        });
      return dummyItemArr;
    }
    const dummyArr = sortDirection(sortingnumber,checkingSort);
    setTableTitle_buy([...dummyMenu])
    setTableData_buy([...dummyArr])
  }

  return (
        <div>
            <div className="table_menu">{materialName} 매입 업체</div>
            <table className="company_main">
              <tr>
                {TableTitle_buy.map((val,i)=>
                  i === 0 ?
                  <th className="toptable"><div className="underline" onClick={()=>sortingTable2(i)}>{val}</div></th>
                  :
                  i === 1 ?
                  <th className="hide"></th>
                  :
                  <th><div className="underline" onClick={()=>sortingTable2(i)}>{val}</div></th>
                )}
              </tr>
              {TableData_buy.map((arrdata,i)=>
                <tr>{
                  arrdata.map((val,i,arr)=>
                  i === 0 ? 
                  <td className="companyname">
                  {
                    val !== '합 계' ?
                    <Link to='/Company_sub' state={{ data: [arr[1],'buy',arr[0]]}} style={{ textDecoration: "none"}}>
                    <div className="rightline" title={val} >{val}</div>
                    </Link> 
                    :
                    <div className="rightline">{val}</div>
                  }
                  </td>
                  :
                  i === 1 ? 
                  <td className="hide"></td>
                  : 
                  <td className="companysales">{val === 0 ? '-' : (commaNumber(val))}</td>
                 )
                }
                </tr>
             )}
            </table>
            <br></br><br></br><br></br>
            <div className="table_menu">{materialName} 매출 업체</div>
            <table className="company_main">
              <tr>
                {TableTitle_sell.map((val,i)=>
                  i === 0 ?
                  <th className="toptable"><div className="underline" onClick={()=>sortingTable(i)}>{val}</div></th>
                  :
                  i === 1 ?
                  <th className="hide"></th>
                  :
                  <th><div className="underline" onClick={()=>sortingTable(i)}>{val}</div></th>
                )}
              </tr>
              {TableData_sell.map((arrdata,i)=>
                <tr>{
                  arrdata.map((val,i,arr)=>
                  i === 0 ? 
                    <td className="companyname">
                    {
                        val !== '합 계' ?
                        <Link to='/Company_sub' state={{ data: [arr[1],'sell',arr[0]]}} style={{ textDecoration: "none"}}>
                        <div className="rightline" title={val}>{val}</div>
                        </Link> 
                        :
                        <div className="rightline">{val}</div>
                    }
                    </td>
                  :
                  i === 1 ? 
                  <td className="hide"></td>
                  : 
                  <td className="companysales">{val === 0 ? '-' : (commaNumber(val))}</td>
                 )
                }
                </tr>
             )}
            </table>
        </div>
    );
}
export default Company_sub_material;